window.addEventListener('load', _ => {
  $('.js-content-hub-filter').on('click', '.js-tracking-item-pulse', function(e) {
      if(dataLayer){
          //console.log($(this).attr('data-tracking-label'));
          dataLayer.push({event:'showLeadecPulse',label:$(this).attr('data-tracking-label')});
      }
  });
});